import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import FunctionForm from "./FunctionForm.vue";
import { useCreateFunction } from "./hooks/useCreateFunction";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateFunction',
  setup(__props) {

const { refCreateFucntion, disableSubmit, loading, visible, toggle, submit } =
  useCreateFunction();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      icon: "pi pi-plus",
      lable: _ctx.$t('new'),
      onClick: _unref(toggle)
    }, null, 8, ["lable", "onClick"]),
    _createVNode(_component_Dialog, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      style: { width: '450px' },
      closable: true
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("new")), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('close'),
          icon: "pi pi-times",
          onClick: _unref(toggle),
          class: "p-button-warning"
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          loading: _unref(loading),
          disabled: _unref(disableSubmit),
          label: _ctx.$t('create0'),
          icon: "pi pi-save",
          "icon-pos": "right",
          onClick: _unref(submit)
        }, null, 8, ["loading", "disabled", "label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(FunctionForm, {
          ref_key: "refCreateFucntion",
          ref: refCreateFucntion
        }, null, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})